import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { FC } from 'react';
import { Page } from '~/components/ui/page';
import { Title } from '~/components/ui/typography';

export const LoadingScreen: FC<Props> = ({ message, backgroundColor, progressColor }) => {
  return (
    <Page innerWrapperSx={{ width: { xs: '100%', sm: '800px' } }} backgroundColor={backgroundColor}>
      <Box mt={7} mb={9} width={{ xs: '100%' }}>
        <Title>{message}</Title>
        <Box my={7}>
          <CircularProgress color="primary" size={'60px'} sx={progressColor ? { color: progressColor } : undefined} />
        </Box>
      </Box>
    </Page>
  );
};

export interface Props {
  message: string;
  /**
   * Neutral overrides for the bootstrap screen, which renders before the tenant
   * colours are known and so must not use the theme's brand colours.
   */
  backgroundColor?: string;
  progressColor?: string;
}
